module.exports = __webpack_public_path__ + "img/line1.4ac2e2c4.svg";